import React from "react";
import * as styles from "./Remark.module.css";
export interface RemarkProps {
  children: React.ReactNode;
  className?: string;
  center?: boolean;
}

const Remark: React.FC<RemarkProps> = ({ children, className, center }) => {
  return (
    <div
      className={`${styles.remark} ${className ? className : ""} ${
        center ? styles.center : ""
      }`}
      role='note'
      aria-label='補足情報'
    >
      <span className={styles.remarkIcon} aria-hidden='true'>
        ※
      </span>
      <div className={styles.remarkContent}>{children}</div>
    </div>
  );
};

export default Remark;
